import React from "react";
import RegisterPage from "scenes/auth/RegisterPage";

const QrRegisterPage = () => (
  <RegisterPage
    kicker="Registrierung"
    title={<>Willkommen bei <em>Dr. Hoffmann</em></>}
    lead="Registriere dich, um Studio- und Vor-Ort-Termine zu buchen, Buchungen zu verwalten und Erinnerungen per E-Mail zu erhalten."
  />
);

export default QrRegisterPage;
